/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceName } from './ServiceName';
import {
    ServiceNameFromJSON,
    ServiceNameFromJSONTyped,
    ServiceNameToJSON,
} from './ServiceName';

/**
 * 
 * @export
 * @interface BackOfficeApiKeyCreateResponse
 */
export interface BackOfficeApiKeyCreateResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BackOfficeApiKeyCreateResponse
     */
    fullAccess: boolean;
    /**
     * 
     * @type {ServiceName}
     * @memberof BackOfficeApiKeyCreateResponse
     */
    service: ServiceName;
    /**
     * Timestamp of the last time this key was used for authentication, or null if never used
     * @type {string}
     * @memberof BackOfficeApiKeyCreateResponse
     */
    lastUsedAt?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BackOfficeApiKeyCreateResponse
     */
    legacy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BackOfficeApiKeyCreateResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BackOfficeApiKeyCreateResponse
     */
    scopes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeApiKeyCreateResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeApiKeyCreateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeApiKeyCreateResponse
     */
    encodedKey: string;
}



/**
 * Check if a given object implements the BackOfficeApiKeyCreateResponse interface.
 */
export function instanceOfBackOfficeApiKeyCreateResponse(value: object): value is BackOfficeApiKeyCreateResponse {
    if (!('fullAccess' in value) || value['fullAccess'] === undefined) return false;
    if (!('service' in value) || value['service'] === undefined) return false;
    if (!('legacy' in value) || value['legacy'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('encodedKey' in value) || value['encodedKey'] === undefined) return false;
    return true;
}

export function BackOfficeApiKeyCreateResponseFromJSON(json: any): BackOfficeApiKeyCreateResponse {
    return BackOfficeApiKeyCreateResponseFromJSONTyped(json, false);
}

export function BackOfficeApiKeyCreateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackOfficeApiKeyCreateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fullAccess': json['fullAccess'],
        'service': ServiceNameFromJSON(json['service']),
        'lastUsedAt': json['lastUsedAt'] == null ? undefined : json['lastUsedAt'],
        'legacy': json['legacy'],
        'isActive': json['isActive'],
        'scopes': json['scopes'],
        'description': json['description'],
        'id': json['id'],
        'encodedKey': json['encodedKey'],
    };
}

export function BackOfficeApiKeyCreateResponseToJSON(value?: BackOfficeApiKeyCreateResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fullAccess': value['fullAccess'],
        'service': ServiceNameToJSON(value['service']),
        'lastUsedAt': value['lastUsedAt'],
        'legacy': value['legacy'],
        'isActive': value['isActive'],
        'scopes': value['scopes'],
        'description': value['description'],
        'id': value['id'],
        'encodedKey': value['encodedKey'],
    };
}

